/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPiggyBank = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M18 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
        <path d="M18 2.382v3.653c.303.24.588.5.853.776a7.98 7.98 0 0 1 1.24 1.681L23 9.22v5.562l-2.908.727c-.706 1.287-1.78 2.368-3.092 3.146V21.5h-2v-1.955c-.943.295-1.953.455-3 .455a9.991 9.991 0 0 1-3-.458V21.5H7v-2.85C4.613 17.237 3 14.828 3 12c0-.057 0-.114.002-.17A3.001 3.001 0 0 1 1 9V8h2v1c0 .305.137.579.353.762C4.453 6.371 7.993 4 12 4c.778 0 1.534.088 2.257.253zm-2 3.236-1.52.76-.369-.1A8.056 8.056 0 0 0 12 6c-3.996 0-7 2.807-7 6 0 3.192 3.004 6 7 6 3.003 0 5.49-1.612 6.502-3.775l.201-.432L21 13.22v-2.438l-2.297-.574-.201-.432a5.895 5.895 0 0 0-1.092-1.58 6.67 6.67 0 0 0-.984-.841l-.426-.3zM11.5 9c-.823 0-1.524.319-1.968.772L8.103 8.373C8.943 7.515 10.169 7 11.5 7s2.557.515 3.397 1.373l-1.43 1.4C13.025 9.318 12.324 9 11.5 9z" />
      </g>
    </g>
  </Icon>
);
export { SvgPiggyBank as PiggyBank };
